import React from 'react';

const CustomSMSIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M22 12H20V5H4V18.385L5.763 17H12V19H6.455L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V12ZM14.145 19.071C13.9505 18.3702 13.9505 17.6298 14.145 16.929L13.17 16.366L14.17 14.634L15.146 15.197C15.6551 14.678 16.2961 14.3077 17 14.126V13H19V14.126C19.715 14.31 20.353 14.686 20.854 15.197L21.83 14.634L22.83 16.366L21.855 16.929C22.0495 17.6298 22.0495 18.3702 21.855 19.071L22.83 19.634L21.83 21.366L20.854 20.803C20.353 21.313 19.714 21.69 19 21.874V23H17V21.874C16.2961 21.6923 15.6551 21.322 15.146 20.803L14.17 21.366L13.17 19.634L14.145 19.071ZM18 20C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18C20 17.4696 19.7893 16.9609 19.4142 16.5858C19.0391 16.2107 18.5304 16 18 16C17.4696 16 16.9609 16.2107 16.5858 16.5858C16.2107 16.9609 16 17.4696 16 18C16 18.5304 16.2107 19.0391 16.5858 19.4142C16.9609 19.7893 17.4696 20 18 20Z"
      fill="currentColor"
    />
  </svg>
);

export default CustomSMSIcon;
